export const EVENT_TYPE = {
  AB_TEST: 'AB_TEST',
  CAROUSEL_NEXT: 'CAROUSEL_NEXT',
  CAROUSEL_PREV: 'CAROUSEL_PREV',
  ITEM_CLICKED: 'ITEM_CLICKED',
  MODULE_VIEW: 'MODULE_VIEW',
  PROMO_VIEW: 'PROMO_VIEW'
};

export const prepareSeptemberPromoEventData = ({
  abTestVariant = null,
  eventType = EVENT_TYPE.MODULE_VIEW,
  styleId = null
}) => {
  switch (eventType) {
    case EVENT_TYPE.AB_TEST:
      return {
        ab_test_group: abTestVariant,
        ab_test_location: 'promotional products category',
        ab_test_name: '2025 09 16 hard goods trending products',
        event: 'ab_test_group'
      };
    case EVENT_TYPE.PROMO_VIEW:
      return {
        ecommerce: {
          creative_name: 'Promotional Products',
          creative_slot: 'Category Page Banner',
          promotion_id: 218,
          promotion_name: 'September 2025 Hard Goods Promo'
        },
        event: 'view_promotion'
      };
    case EVENT_TYPE.MODULE_VIEW:
      return {
        event: 'category_interaction',
        interaction_action: 'module view',
        interaction_category: 'trending products'
      };
    case EVENT_TYPE.ITEM_CLICKED:
      return {
        event: 'category_interaction',
        interaction_action: 'click product',
        interaction_category: 'trending products',
        product_style_id: String(styleId)
      };
    case EVENT_TYPE.CAROUSEL_NEXT:
      return {
        event: 'category_interaction',
        interaction_action: 'click next',
        interaction_category: 'trending products'
      };
    case EVENT_TYPE.CAROUSEL_PREV:
      return {
        event: 'category_interaction',
        interaction_action: 'click previous',
        interaction_category: 'trending products'
      };
    default:
      return null;
  }
};

export const fireSeptemberPromoEvent = (eventData) => {
  window.dataLayer.push(prepareSeptemberPromoEventData(eventData));
};

export const fireSeptemberPromoEventWithCallback = ({callback, eventData}) => {
  const data = prepareSeptemberPromoEventData(eventData);
  window.dataLayer.push({
    ...data,
    eventCallback: callback,
    eventTimeout: 1500
  });
};
